import React, { useEffect, useState, useRef, lazy } from 'react';
import { CTAButton } from './CTAButton';
import { CheckIcon, ChevronLeftIcon, ChevronRightIcon, StarIcon } from 'lucide-react';
const CHECKOUT_URL = 'https://p2rxju-de.myshopify.com/cart/44671911067783:1?channel=buy_button';
const heroTestimonials = [{
  initials: 'MG',
  name: 'Mariela G.',
  role: 'Dueña Estética — Buenos Aires',
  quote: 'Sumé Brow Extensions a mi salón en Recoleta y estoy trabajando con +50 clientas nuevas estoy muy feliz!!'
}, {
  initials: 'LP',
  name: 'Laura P.',
  role: 'Esteticista — Córdoba',
  quote: 'Mis clientas de pestañas y laminado amaron el nuevo servicio... vuelven cada 3 semanas por Brow Extensions también'
}, {
  initials: 'RM',
  name: 'Rocío M.',
  role: 'Lashista — Rosario',
  quote: 'Llené mi agenda en una sola semana ofreciendo el servicio'
}];
const resultImages = ['https://cdn.magicpatterns.com/uploads/eA7mtCbRQrGw8Qn2PutU2F/WhatsApp_Image_2026-05-03_at_07.20.44.jpg', 'https://cdn.magicpatterns.com/uploads/7i74A1uN2D5Dy3E6WCpqoi/ChatGPT_Image_29_abr_2026,_07_21_51_p.m..png', 'https://cdn.magicpatterns.com/uploads/wL6aGDqFb48777ZA8eDtJx/WhatsApp_Image_2026-05-03_at_06.59.12.jpg', 'https://cdn.magicpatterns.com/uploads/qS5YCMNmBBeqUf22EATP66/ad7.jpg', 'https://cdn.magicpatterns.com/uploads/fs4t5fx5ZfJXFUVgXYYmCu/ad2.jpg'];
const beforeImages = ['https://cdn.magicpatterns.com/uploads/befWjZNtk1Kzw6ruZphVyD/WhatsApp_Image_2026-05-02_at_22.08.03_(2).jpg', 'https://cdn.magicpatterns.com/uploads/g1egev8N4akbkZNtXocYzF/WhatsApp_Image_2026-05-02_at_22.08.03.jpg', 'https://cdn.magicpatterns.com/uploads/2K1CzXbcjYAezJTLa9sUSn/WhatsApp_Image_2026-05-02_at_22.15.42_(1).jpg'];
const lifeImages = ['https://cdn.magicpatterns.com/uploads/aL8Qcf1YcrbW3qCyv9ZFv8/WhatsApp_Image_2aa026-05-14_at_16.46.06_(3).jpg', 'https://cdn.magicpatterns.com/uploads/mvG1ANNPzfchqGvTXf38pD/WhatsApp_Image_2026-0a5-14_at_16.46.08_(2).jpg', 'https://cdn.magicpatterns.com/uploads/2DBJroGFbEQs5VRnDfsCpc/WhatsApp_Image_20d26-05-14_at_16.46.11.jpg', 'https://cdn.magicpatterns.com/uploads/gpL8XCTS7ums77QJZmEbh1/WhatsApp_Image_2026-j05-14_at_16.46.10_(1).jpg'];
const browTechniqueImages = ['https://cdn.magicpatterns.com/uploads/j5JTBTtCXaaFoDdZcPAaia/ChatGPT_Image_124_may_2026,_18_58_31.png', 'https://cdn.magicpatterns.com/uploads/cXWTGoBn2BYkM77XrHDfS8/WhatsApp_Image_2026-05-14_at_1a6.46.10_(2).jpg', 'https://cdn.magicpatterns.com/uploads/rY5WRbTAZQZQeX9CNFMbog/WhatsApp_Image_2026-05-14_at_16s.46.06_(2).jpg'];
export function HeroSection() {
  const [beforeSlide, setBeforeSlide] = useState(0);
  const [lifeSlide, setLifeSlide] = useState(0);
  const [browSlide, setBrowSlide] = useState(0);
  const [alumnasCount, setAlumnasCount] = useState(0);
  const statsRef = useRef<HTMLDivElement | null>(null);
  const hasAnimatedRef = useRef(false);
  useEffect(() => {
    if (!statsRef.current) return;
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !hasAnimatedRef.current) {
          hasAnimatedRef.current = true;
          const target = 357;
          const duration = 2000;
          const startTime = performance.now();
          const step = (now: number) => {
            const elapsed = now - startTime;
            const progress = Math.min(elapsed / duration, 1);
            const eased = 1 - Math.pow(1 - progress, 3);
            setAlumnasCount(Math.floor(eased * target));
            if (progress < 1) {
              requestAnimationFrame(step);
            } else {
              setAlumnasCount(target);
            }
          };
          requestAnimationFrame(step);
        }
      });
    }, {
      threshold: 0.3
    });
    observer.observe(statsRef.current);
    return () => observer.disconnect();
  }, []);
  useEffect(() => {
    const timer = setInterval(() => {
      setBeforeSlide(prev => (prev + 1) % beforeImages.length);
    }, 3000);
    return () => clearInterval(timer);
  }, []);
  useEffect(() => {
    const timer = setInterval(() => {
      setLifeSlide(prev => (prev + 1) % lifeImages.length);
    }, 3500);
    return () => clearInterval(timer);
  }, []);
  useEffect(() => {
    const timer = setInterval(() => {
      setBrowSlide(prev => (prev + 1) % browTechniqueImages.length);
    }, 3500);
    return () => clearInterval(timer);
  }, []);
  const scrollToCompra = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const painPoints = [{
    emoji: '❌',
    before: 'El rubro beauty está ',
    bold: 'cada vez más saturado',
    after: ''
  }, {
    emoji: '❌',
    before: 'Hay demasiadas lashistas ',
    bold: 'ofreciendo lo mismo',
    after: ''
  }, {
    emoji: '❌',
    before: 'Las clientas ya ',
    bold: 'no se sorprenden fácilmente',
    after: ''
  }, {
    emoji: '❌',
    before: 'Querés diferenciarte pero ',
    bold: 'no sabés con qué',
    after: ''
  }, {
    emoji: '❌',
    before: 'Ves técnicas internacionales en redes… pero ',
    bold: 'nadie las enseña bien en Argentina',
    after: ''
  }];
  return <section className="py-6 md:py-10 px-4 pt-[0px] pb-[0px] bg-[#2F0240] space-y-[0px]" data-id="element-86" data-mp="aheszkoqqdry">
      <div className="max-w-6xl mx-auto" data-id="element-87" data-mp="3ix86rrrotb5b">
        <div className="text-center mb-8" data-id="element-88" data-mp="3iy9k62w6e9q7">
          <div className="inline-flex items-center gap-2 text-white px-6 py-2.5 rounded-full font-bold text-sm uppercase tracking-wider shadow-[0_0_15px_rgba(34,197,94,0.5)] animate-glow-badge pt-[6px] pb-[6px] mt-[10px] mb-[10px] bg-[#9C16A3]" data-id="element-89" data-mp="3ev3iz9nx78ql">
            <span data-id="element-90" data-mp="3ntym2cvo42po"></span>
            <span data-id="element-91" data-mp="1845d64n82if6">50% OFF - CUPOS LIMITADOS</span>
          </div>

          <h2 className="md:text-5xl font-black mb-4 max-w-5xl mx-auto uppercase text-[#FFFFFF] text-[27px]" data-id="element-92" data-mp="182aqakse4g8g">
            <span className="text-[#FACC15]" data-id="element-93" data-mp="137573tqdhfo2">BROW EXTENSIONS:</span> La Nueva
            Tendencia Que Está por Explotar en Argentina✨
          </h2>
          <h3 className="md:text-3xl font-bold mb-8 max-w-5xl mx-auto uppercase text-[#FC9DFF] text-[20px]" data-id="element-94" data-mp="1f6kc2gy26rdm">
            Y podés ser una de las primeras en ofrecerlo...
          </h3>

          <div className="flex justify-center mb-8" data-id="element-95" data-mp="1p59lrmfsx5is">
            <div className="w-full max-w-lg mt-[-20px] mb-[-20px]" data-id="element-96" data-mp="1p4qbmrwe7lfb">
              <div className="relative" data-id="element-97" data-mp="risogh72irx1">
                <div className="overflow-hidden rounded-lg shadow-2xl" data-id="element-98" data-mp="rfodn0z3kxxe">
                  <div className="flex transition-transform duration-500 ease-in-out" style={{
                  transform: `translateX(-${browSlide * 100}%)`
                }} data-id="element-99" data-mp="whdoogmblblh">
                    {browTechniqueImages.map((img, index) => <img key={index} src={img} alt={`Brow Extensions - Técnica Hiperrealista ${index + 1}`} loading="lazy" className="w-full flex-shrink-0 aspect-square object-cover" data-id="element-100" data-mp="8qzvgms016pb" data-mpi={index} />)}
                  </div>
                </div>
                <button onClick={() => setBrowSlide(prev => (prev - 1 + browTechniqueImages.length) % browTechniqueImages.length)} className="absolute left-2 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white rounded-full p-2 transition-colors" aria-label="Anterior" data-id="element-101" data-mp="3sc74ji0pesqo">
                  <ChevronLeftIcon className="w-5 h-5" data-id="element-102" data-mp="34q0ny7d7s4ou" />
                </button>
                <button onClick={() => setBrowSlide(prev => (prev + 1) % browTechniqueImages.length)} className="absolute right-2 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white rounded-full p-2 transition-colors" aria-label="Siguiente" data-id="element-103" data-mp="2zob9siup3awj">
                  <ChevronRightIcon className="w-5 h-5" data-id="element-104" data-mp="dg3sv5okb6ks" />
                </button>
                <div className="flex justify-center gap-2 mt-3" data-id="element-105" data-mp="ieylezcc09i3">
                  {browTechniqueImages.map((_, index) => <button key={index} onClick={() => setBrowSlide(index)} className={`w-2.5 h-2.5 rounded-full transition-all ${browSlide === index ? 'bg-[#FC9DFF] scale-125' : 'bg-gray-500 hover:bg-gray-400'}`} aria-label={`Ir a slide ${index + 1}`} data-id="element-106" data-mp="4n0fsyhtwvqo" data-mpi={index} />)}
                </div>
              </div>
            </div>
          </div>

          <p className="md:text-2xl max-w-4xl mx-auto pt-[0px] pb-[0px] text-[17px] font-[500] mt-[0px] mb-[0px] text-[#FFFFFF]" data-id="element-107" data-mp="3lx8atdov9dps">
            ✨ Aprendé la técnica hiperrealista que complementa pestañas,
            microblading y laminado.
          </p>

          <p className="md:text-2xl max-w-4xl mx-auto text-[17px] font-[500] mt-[0px] mb-[0px] text-[#FC9DFF] pt-[5px] pb-[5px]" data-id="element-108" data-mp="2ybehujxwtxe3"></p>

          <div className="rounded-xl p-6 max-w-3xl mx-auto bg-[#9C16A3] animate-neon-violet pt-[15px] pb-[15px] mt-[15px] mb-[15px] pl-[0px] pr-[0px]" data-id="element-109" data-mp="37a9mvsp7x1ft">
            <p className="md:text-xl font-[600] font-[Montserrat,_sans-serif] text-[#FFFFFF] text-[15px]" data-id="element-110" data-mp="3m5fuul7vjabs">
              ✨ Ofrecé un servicio PREMIUM que ya es FUROR en Europa y LATAM🔥
            </p>
          </div>

          <div className="flex justify-center my-8" data-id="element-111" data-mp="3v1ox07n8kn1m">
            <button type="button" onClick={scrollToCompra} className="inline-block w-full md:w-auto px-8 py-4 text-lg md:text-xl font-black text-white bg-[#BE19BE] hover:bg-[#A015A0] rounded-lg text-center shadow-[0_0_15px_rgba(190,25,190,0.5),0_0_30px_rgba(190,25,190,0.3)] hover:shadow-[0_0_25px_rgba(190,25,190,0.7),0_0_50px_rgba(190,25,190,0.4)] transform hover:scale-105 transition-all duration-200 animate-cta-wiggle" data-id="element-112" data-mp="3qz1zbq3vw7wi">
              QUIERO SER LA PRIMERA 👉
            </button>
          </div>

          <p className="text-lg text-gray-600 mb-8 max-w-3xl mx-auto" data-id="element-113" data-mp="2d16uzny9a7kb"></p>
        </div>

        <div className="text-center mt-[-10px] mb-[-10px]" data-id="element-114" data-mp="2czdm02067b95">
          <CTAButton text="QUIERO SER LA PRIMERA👉🏻" onClick={scrollToCompra} size="large" className="w-full md:w-auto text-2xl" data-id="element-115" data-mp="39q64t7ehnhem" />
        </div>

        <div className="max-w-md mx-auto mb-10" data-id="element-116" data-mp="30phna2pvyywz">
          <div className="flex justify-center mb-6" data-id="element-117" data-mp="2vrohhashw6x8">
            <CTAButton text="QUIERO SER LA PRIMERA 👉" onClick={scrollToCompra} size="large" className="w-full !bg-[#BE19BE] hover:!bg-[#A015A0] !text-white font-black text-xl shadow-[0_0_20px_rgba(190,25,190,0.6)] animate-pulse" data-id="element-118" data-mp="2vr6ezwf8owgv" />
          </div>
          <h3 className="md:text-3xl text-center uppercase text-[10px] font-[400] text-[#FFFFFF] pt-[15px] pb-[15px] mt-[-30px] mb-[-30px]" data-id="element-119" data-mp="1aafddglfoji4">
            🛡️ Garantía 7 días 🔒 Pago seguro 💳 Mercado Pago ⭐+357 Alumnas
            ⚡Acceso en 5 minutos
          </h3>

          <div ref={statsRef} className="mt-6 rounded-3xl bg-[#1a0124] border border-[#FC9DFF]/30 shadow-2xl p-6 md:p-7" data-id="element-120" data-mp="1oyjz6tfs9b54">
            {/* Stats grid */}
            <div className="grid grid-cols-2 gap-x-4 gap-y-6 mb-7" data-id="element-121" data-mp="1xxdtue9jzrg1">
              <div className="text-left" data-id="element-122" data-mp="22x9x2baffeuj">
                <div className="text-white font-black text-[40px] leading-none tracking-tight tabular-nums" data-id="element-123" data-mp="22yl20eflysn8">
                  +{alumnasCount}
                </div>
                <div className="text-[#FC9DFF] font-semibold text-sm mt-2 leading-snug" data-id="element-124" data-mp="8jigssxldwq4">
                  alumnas en Europa y Latinoamérica
                </div>
              </div>
              <div className="text-left" data-id="element-125" data-mp="5hnqqhgoyftn">
                <div className="text-white font-black text-[40px] leading-none tracking-tight" data-id="element-126" data-mp="5ip10jpvuyab">
                  27
                </div>
                <div className="text-[#FC9DFF] font-semibold text-sm mt-2 leading-snug" data-id="element-127" data-mp="knlu9vkvj44">
                  clases completamente listas
                </div>
              </div>
              <div className="text-left" data-id="element-128" data-mp="af5qbh8tjioz">
                <div className="text-white font-black text-[40px] leading-none tracking-tight flex items-baseline gap-1" data-id="element-129" data-mp="ogi4bn4f5a88">
                  4.9
                  <span className="text-[24px] text-white/70" data-id="element-130" data-mp="jgnezo0akspa">/5</span>
                </div>
                <div className="text-[#FC9DFF] font-semibold text-sm mt-2 leading-snug flex items-center gap-1" data-id="element-131" data-mp="y59upqttzmh1">
                  calificación
                  <StarIcon className="w-4 h-4 fill-[#FC9DFF] text-[#FC9DFF]" data-id="element-132" data-mp="t9kq392yffdv" />
                </div>
              </div>
              <div className="text-left" data-id="element-133" data-mp="135o2r8vfmwf2">
                <div className="text-[40px] leading-none" data-id="element-134" data-mp="136pd1b4mjevq">🌎</div>
                <div className="text-[#FC9DFF] font-semibold text-sm mt-2 leading-snug" data-id="element-135" data-mp="1lt6pe1vaykda">
                  Todo el mundo hispanohablante
                </div>
              </div>
            </div>

            {/* Testimonial cards */}
            <div className="space-y-3" data-id="element-136" data-mp="1cs8inbthbyr0">
              {heroTestimonials.map((t, i) => <div key={i} className="rounded-2xl border border-[#FC9DFF]/40 bg-[#2F0240]/60 p-4 flex gap-3 items-start" data-id="element-137" data-mp="1hr1tsxlando0" data-mpi={i}>
                  <div className="flex-shrink-0 w-11 h-11 rounded-full bg-[#9C16A3] flex items-center justify-center text-[#FC9DFF] font-black text-sm" data-id="element-138" data-mp="17ugoeb5d40jn">
                    {t.initials}
                  </div>
                  <div className="flex-1 min-w-0" data-id="element-139" data-mp="y3ca7dnigjpv">
                    <div className="flex items-center gap-0.5 mb-1" data-id="element-140" data-mp="y1rh7sguh8u4">
                      {Array.from({
                    length: 5
                  }).map((_, idx) => <StarIcon key={idx} className="w-4 h-4 fill-[#FC9DFF] text-[#FC9DFF]" data-id="element-141" data-mp="p2o1mygvzbkd" data-mpi={idx} />)}
                    </div>
                    <p className="text-white font-bold text-[15px] leading-snug mb-1" data-id="element-142" data-mp="1iojvr44f4q0k">
                      "{t.quote}"
                    </p>
                    <p className="text-white/70 text-xs leading-snug" data-id="element-143" data-mp="1doe2jjii2vgd">
                      — {t.name} | {t.role}
                    </p>
                  </div>
                </div>)}
            </div>
          </div>
        </div>

        <div className="rounded-2xl p-8 md:p-10 mb-10 max-w-3xl mx-auto bg-[#3E0400] pt-[20px] pb-[20px]" data-id="element-144" data-mp="13tm30a5cxyiy">
          <h3 className="md:text-4xl font-black mb-8 text-center font-[Inter,_sans-serif] text-[#FFFFFF] text-[20px]" data-id="element-145" data-mp="uqkww9ghs7fa">
            Si sos lashista, esteticista, especialista en laminado de cejas o
            microblading... esto te va a sonar familiar:
          </h3>
          <div className="space-y-4" data-id="element-146" data-mp="2p5dps0pzqk3j">
            {painPoints.map((point, index) => <div key={index} className="flex items-center gap-4 border border-amber-600/40 rounded-xl px-5 py-4 bg-gray-900/60" data-id="element-147" data-mp="2wnlnpodkjuac" data-mpi={index}>
                <span className="text-2xl flex-shrink-0 bg-gray-800 rounded-lg w-10 h-10 flex items-center justify-center" data-id="element-148" data-mp="36ezhdfiu9zvk">
                  {point.emoji}
                </span>
                <p className="text-base md:text-lg font-medium text-[#FFFFFF]" data-id="element-149" data-mp="2dpsk0jv4fgbw">
                  {point.before}
                  <span className="font-bold text-[#FC9DFF]" data-id="element-150" data-mp="2inke9kj8nej9">{point.bold}</span>
                  {point.after}
                </p>
              </div>)}
          </div>
          <p className="text-center text-base md:text-lg font-semibold text-[#FC9DFF] mt-8 italic leading-relaxed" data-id="element-151" data-mp="2rosc61huedct"></p>
        </div>

        <div className="max-w-2xl mx-auto mb-4" data-id="element-152" data-mp="2wfyv4pyq8dy">
          <div className="rounded-2xl p-6 md:p-8 bg-[#1a0124] border border-[#FC9DFF]/30 shadow-xl" data-id="element-153" data-mp="6yt4zu8mg8b9">
            <p className="md:text-xl font-bold mb-4 text-[18px] font-[Montserrat,_sans-serif] text-[#FACC15]" data-id="element-154" data-mp="23zfegg5gr05c">
              Y seguramente a muchas de tus clientas les sucede que...
            </p>
            <p className="md:text-lg text-white mb-4 text-[16px] font-[500] font-[Montserrat,_sans-serif] leading-relaxed" data-id="element-155" data-mp="2d057jc3cacfd">
              Ya se realizaron{' '}
              <span className="font-bold text-[#FC9DFF]" data-id="element-156" data-mp="281k6xbk6dqqe">
                microblading o sombreado de cejas
              </span>
              .
            </p>
            <p className="md:text-lg text-white mb-3 text-[16px] font-[500] font-[Montserrat,_sans-serif]" data-id="element-157" data-mp="1gaedfdyymra3">
              Pero siguen sintiendo que:
            </p>
            <ul className="space-y-3 text-left mb-5" data-id="element-158" data-mp="1u343bthm0gch">
              <li className="md:text-lg font-[Montserrat,_sans-serif] text-[16px] font-[500] text-[#FF9292]" data-id="element-159" data-mp="1p9hwihy4n6ol">
                ❌ las cejas se ven "dibujadas"
              </li>
              <li className="md:text-lg font-[Montserrat,_sans-serif] text-[16px] font-[500] text-[#FF9292]" data-id="element-160" data-mp="wmf487k1ns6s">
                ❌ les falta textura real
              </li>
              <li className="md:text-lg font-[Montserrat,_sans-serif] text-[16px] font-[500] text-[#FF9292]" data-id="element-161" data-mp="387e6w31c1xhy">
                ❌ quieren un acabado más natural
              </li>
              <li className="md:text-lg font-[Montserrat,_sans-serif] text-[16px] font-[500] text-[#FF9292]" data-id="element-162" data-mp="2zadnkat4epld">
                ❌ desean más hiperrealismo
              </li>
            </ul>
            <div className="my-5" data-id="element-163" data-mp="3rxpy1mm0b6yb">
              <img src="https://cdn.magicpatterns.com/uploads/vubQeaQEpXXQL9tzzdahZt/ChatGPT_Image_15_may_2026,_01_18_18.png" alt="Comparación cejas con y sin Brow Extensions" loading="lazy" className="w-full rounded-xl shadow-lg" data-id="element-164" data-mp="3vytdw94212zj" />
            </div>
          </div>
        </div>

        <div className="max-w-3xl mx-auto mb-4 text-center" data-id="element-165" data-mp="26iag6sga5qww">
          <p className="md:text-xl mb-3 font-[600] font-[Montserrat,_sans-serif] text-[#FFFFFF] text-[22px]" data-id="element-166" data-mp="2bjhoqtq8yu4m">
            La realidad es que ya no alcanza con hacer pestañas, microblading o
            laminado.
          </p>
        </div>

        <div className="max-w-2xl mx-auto mb-4" data-id="element-167" data-mp="2y5ve07vbstq4">
          <div className="rounded-2xl p-6 md:p-8 bg-[#1a0124] border border-[#FC9DFF]/30 shadow-xl" data-id="element-168" data-mp="2t83kj9f18zjt">
            <p className="md:text-xl font-bold text-white mb-4 text-[18px] font-[Montserrat,_sans-serif]" data-id="element-169" data-mp="2o9infiv2uvzl">
              Las clientas buscan:
            </p>
            <ul className="space-y-3 text-left" data-id="element-170" data-mp="3lw959w636ojn">
              <li className="md:text-lg text-white font-[Montserrat,_sans-serif] text-[16px] font-[500]" data-id="element-171" data-mp="3gxeheft9i9so">
                ✨ resultados mucho más realistas
              </li>
              <li className="md:text-lg text-white font-[Montserrat,_sans-serif] text-[16px] font-[500]" data-id="element-172" data-mp="3784ncueuyh1x">
                ✨ técnicas innovadoras
              </li>
              <li className="md:text-lg text-white font-[Montserrat,_sans-serif] text-[16px] font-[500]" data-id="element-173" data-mp="8jpejammtbp3">
                ✨ servicios exclusivos
              </li>
              <li className="md:text-lg text-white font-[Montserrat,_sans-serif] text-[16px] font-[500]" data-id="element-174" data-mp="c0tua54owdri">
                ✨ profesionales actualizadas
              </li>
              <li className="md:text-lg text-white font-[Montserrat,_sans-serif] text-[16px] font-[500]" data-id="element-175" data-mp="l0qdhr8b8kf6">
                ✨ experiencias premium
              </li>
            </ul>
            <p className="md:text-lg text-[#FC9DFF] font-semibold mt-5 text-[16px] font-[Montserrat,_sans-serif] leading-relaxed" data-id="element-176" data-mp="pxqjk255tn6a"></p>
          </div>
        </div>

        <div className="max-w-3xl mx-auto mb-4 text-center mt-10" data-id="element-177" data-mp="yzgbra6v8q54">
          <h3 className="text-2xl md:text-4xl font-black text-[#FACC15] leading-tight" data-id="element-178" data-mp="13rhqd2riasyb">
            👉🏻Hoy, los salones y showroom que más crecen son los que incorporan
            tendencias antes que el resto.
          </h3>
        </div>

        <div className="max-w-2xl mx-auto mb-4 mt-8" data-id="element-179" data-mp="1dqyxzpqbjgwx">
          <div className="rounded-2xl p-6 md:p-8 bg-[#1a0124] border border-[#FC9DFF]/30 shadow-xl" data-id="element-180" data-mp="1io8tnn4awot7">
            <h4 className="md:text-2xl font-black mb-4 text-[20px] font-[Montserrat,_sans-serif] leading-snug text-[#FC9DFF]" data-id="element-181" data-mp="2h7mm2zw0fiea">
              Ahí es donde entra la Extensión de Cejas Pelo por Pelo.
            </h4>
            <p className="md:text-lg text-white mb-5 text-[16px] font-[500] font-[Montserrat,_sans-serif] leading-relaxed" data-id="element-182" data-mp="2r510ktydhx3y">
              Una técnica que ya es un{' '}
              <span className="font-bold text-[#FC9DFF]" data-id="element-183" data-mp="305yv8lmx8s9v">
                éxito internacional
              </span>{' '}
              y que está a punto de explotar en Argentina...
            </p>
            <p className="md:text-lg mb-3 text-[16px] font-[600] font-[Montserrat,_sans-serif] text-[#FFFFFF]" data-id="element-184" data-mp="39vs6tmn2d7e4">
              Porque permite:
            </p>
            <ul className="space-y-3 text-left mb-5" data-id="element-185" data-mp="3eubupsl7wt94">
              <li className="md:text-lg font-[Montserrat,_sans-serif] text-[16px] font-[500] text-[#9DFF77]" data-id="element-186" data-mp="3ju809w9kcsqs">
                ✔ reconstruir cejas despobladas
              </li>
              <li className="md:text-lg font-[Montserrat,_sans-serif] text-[16px] font-[500] text-[#9DFF77]" data-id="element-187" data-mp="3nt7052gftzbd">
                ✔ corregir asimetrías
              </li>
              <li className="md:text-lg font-[Montserrat,_sans-serif] text-[16px] font-[500] text-[#9DFF77]" data-id="element-188" data-mp="1851i99u26shl">
                ✔ crear efecto hiperrealista
              </li>
              <li className="md:text-lg font-[Montserrat,_sans-serif] text-[16px] font-[500] text-[#9DFF77]" data-id="element-189" data-mp="y984xo8imuyr">
                ✔ rejuvenecer el rostro
              </li>
              <li className="md:text-lg font-[Montserrat,_sans-serif] text-[16px] font-[500] text-[#9DFF77]" data-id="element-190" data-mp="1qx4552xan50a">
                ✔ complementar microblading
              </li>
              <li className="md:text-lg font-[Montserrat,_sans-serif] text-[16px] font-[500] text-[#9DFF77]" data-id="element-191" data-mp="1m4ay28ecrkl1">
                ✔ generar mantenimientos recurrentes
              </li>
            </ul>
            <p className="md:text-lg font-bold mt-5 mb-4 text-[16px] font-[Montserrat,_sans-serif] leading-relaxed text-[#FFFFFF]" data-id="element-192" data-mp="2eorlws0uczou">
              Y lo mejor: todavía hay MUY poca competencia.
            </p>
          </div>
        </div>

        <div className="max-w-sm mx-auto mb-4" data-id="element-193" data-mp="bzrmu6zt0rm7">
          <div className="relative" data-id="element-194" data-mp="bzhuicrae8dc">
            <div className="overflow-hidden rounded-2xl shadow-xl" data-id="element-195" data-mp="3ue0peaeb2m5w">
              <div className="flex transition-transform duration-700 ease-in-out" style={{
              transform: `translateX(-${lifeSlide * 100}%)`
            }} data-id="element-196" data-mp="3udqxuidm46y3">
                {lifeImages.map((img, index) => <img key={index} src={img} alt={`Nuestra vida ahora ${index + 1}`} loading="lazy" className="w-full flex-shrink-0 object-cover aspect-square" data-id="element-197" data-mp="3pfpb9ngz9phv" data-mpi={index} />)}
              </div>
            </div>
            <div className="flex justify-center gap-2 mt-3" data-id="element-198" data-mp="19lxfhoix9o5n">
              {lifeImages.map((_, index) => <button key={index} onClick={() => setLifeSlide(index)} className={`w-2.5 h-2.5 rounded-full transition-all ${lifeSlide === index ? 'bg-[#FC9DFF] scale-125' : 'bg-gray-500 hover:bg-gray-400'}`} data-id="element-199" data-mp="1oqt56zhh5umo" data-mpi={index} />)}
            </div>
          </div>
          <p className="text-center md:text-lg text-gray-200 mt-4 font-medium px-2 text-[17px] font-[Montserrat,_sans-serif]" data-id="element-200" data-mp="1ss4xxdvnavz3">
            ✨Ejemplos reales Brow Extensions✨
          </p>
        </div>

        <div className="max-w-3xl mx-auto mb-4 text-center mt-12" data-id="element-201" data-mp="22izk6i8w5vkj">
          <h3 className="md:text-4xl font-[700] font-[Montserrat,_sans-serif] text-[#FC9DFF] mt-[0px] mb-[0px] text-[22px]" data-id="element-202" data-mp="2ghz97r0bgch8">
            ¿Te imaginás poder ofrecerlo primero en tu zona...
          </h3>
          <p className="md:text-lg text-white text-[16px] font-[500] font-[Montserrat,_sans-serif] leading-relaxed mt-[30px] mb-[30px]" data-id="element-203" data-mp="m3yenibsubmy">
            Las mismas clientas que vuelven todos los meses por{' '}
            <span className="font-bold text-[#FC9DFF]" data-id="element-204" data-mp="jjs7l1rw2526">
              pestañas o laminado
            </span>
            … pueden convertirse en tus próximas clientas Brow✨
          </p>
          <p className="md:text-2xl font-semibold text-white font-[Montserrat,_sans-serif] pt-[0px] pb-[0px] text-[30px]" data-id="element-205" data-mp="sk6w0a05g09w">
            Es por eso que creamos el Programa{' '}
            <span className="text-[#FC9DFF] font-black" data-id="element-206" data-mp="xii3wf6vw0ph">BROW EXTENSIONS</span>
          </p>
        </div>

        <div className="max-w-2xl mx-auto mb-4" data-id="element-207" data-mp="qxtsb604izj">
          <img src="https://cdn.magicpatterns.com/uploads/68QWgGoKk9HTa8pZ5e2tNV/mockup_dominando_shopify_(1).png" alt="Programa Brow Extensions - Mockup" loading="lazy" className="w-full rounded-2xl shadow-2xl" data-id="element-208" data-mp="4tui8ii839be" />
          <p className="text-center md:text-lg font-medium px-2 font-[Montserrat,_sans-serif] text-[#FC9DFF] pt-[10px] pb-[10px] mt-[0px] mb-[0px] text-[17px]" data-id="element-209" data-mp="3dafklggcn45j">
            🏆 El sistema más completo de extensión de cejas pelo por pelo y
            negocio para profesionales beauty de Argentina ✨
          </p>
        </div>
      </div>
    </section>;
}